import Axios from 'axios';
import { Config } from './config';

const axiosInstance = Axios.create({
  baseURL: Config.baseURL,
  headers: { 'Content-Type': 'application/json', "Platform-Type" : "web" }
});

export default axiosInstance;